import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D7CAB5D9-2494-4528-B45E-A8EA49EA8262
 * name sim-off-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sim-off-outline.svg
 * tags
 * - Cellphone / Phone 
 */
export const SimOffOutlineIcon = createSvgIcon(<><path d="M22.11 21.46L2.39 1.73L1.11 3L5.06 6.95L4 8V20C4 21.11 4.89 22 6 22H18C18.58 22 19.1 21.75 19.46 21.35L20.84 22.73L22.11 21.46M18 20H6V8.83L6.47 8.36L18 19.89V20M10.83 4H18V14.8L20 16.8V4C20 2.9 19.11 2 18 2H10L7.6 4.4L9 5.81L10.83 4Z" /></>, 'SimOffOutlineIcon');
export default SimOffOutlineIcon